import { render, staticRenderFns } from "./VerificationSettings.vue?vue&type=template&id=25799ce5&scoped=true"
import script from "./VerificationSettings.vue?vue&type=script&lang=js"
export * from "./VerificationSettings.vue?vue&type=script&lang=js"
import style0 from "./VerificationSettings.vue?vue&type=style&index=0&id=25799ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25799ce5",
  null
  
)

export default component.exports